// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#document-edit[data-v-cfbbab14] p{line-height:unset!important}#document-edit[data-v-cfbbab14] .quill-img-max-width img{max-width:100%}", ""]);
// Exports
module.exports = exports;
